import * as actionTypes from "./actionTypes";

export const setCurrentStep = (value) => {
  return {
    type: actionTypes.SET_CURRENT_STEP,
    value,
  };
};

export const setCoderStatus = (value) => {
  return {
    type: actionTypes.SET_CODER_STATUS,
    value,
  };
};

export const setShouldOpenPdfModal = (value) => {
  return {
    type: actionTypes.SET_SHOULD_SHOW_PDF_MODAL,
    value,
  };
};

export const setShouldOpenClearModal = (value) => {
  return {
    type: actionTypes.SET_SHOULD_SHOW_CLEAR_MODAL,
    value,
  };
};
